import { assert, Callback, Callback1 } from '@deqo/foundation';
import { Arr } from '../../../CodesForFoundation';


export const aspect = () =>
    (_target: unknown, key: string | symbol, descriptor: PropertyDescriptor): PropertyDescriptor => {
        descriptor.get = createAspect(descriptor.get);
        return descriptor;
    };

const createAspect = (producer: Callback<any>) => {

    let selector = null as Callback1<any[], any> | null;
    let valueInputs = null as any[] | null;
    let value = null as any | null;

    return function () {
        if (!!selector && !!valueInputs) {
            const newInputs = selector(this);
            if (!Arr.equals(newInputs, valueInputs)) {
                value = producer.call(this);
                valueInputs = newInputs;
            }
        }
        else {
            const paths = [] as any[][];
            const rootProxy = createProxy(this, paths, []);
            value = producer.call(rootProxy);
            selector = createSelector(paths);
            valueInputs = selector(this);
        }
        return value!;
    };
};

const createProxy = (target: any, paths: any[][], ownPath: any[]) =>
    new Proxy(prepareTarget(target), {
        get(t, p) {
            const v = t[p];
            assert(typeof v !== 'function', 'Cannot create aspect that calls methods, behavior must be uniform.');
            if (typeof v === 'object') {
                return createProxy(v, paths, ownPath.concat([p]));
            }
            else {
                paths.push(ownPath.concat([p]));
                return v;
            }
        },
    });

const prepareTarget = (target: any) => Object.isFrozen(target) ? { ...target } : target;

const createSelector = (paths: any[][]) =>
    (root: any) => paths.map(p => resolvePath(root, p));

const resolvePath = (root: any, path: any[]): any => {
    let val = root;
    for (const ps of path) {
        val = val[ps];
    }
    return val;
};
